module.exports = __webpack_public_path__ + "img/load-rawk-4.910367d3.gif";